import { useEffect } from 'react';
import { API } from '@unboared/react';

import { reloadScreen } from '~/unboared/config/screenSocketAudit';

/**
 * Screen-side recovery when the server terminates the session (server restart,
 * host grace period expired after a long TV outage...).
 *
 * The screen is unattended (bar TV, airport): reloading the page is the most
 * robust recovery — UnboaredGame fails to resume the dead session and falls
 * back to a fresh createSession, displaying a new QR code. The console never
 * deletes its own session, so this only fires on server-initiated closures.
 */
export function ScreenSessionRecovery() {
    useEffect(() => {
        const unsubscribe = API.onSessionClosed(() => {
            // Small random delay: if the closure comes from a server restart,
            // avoid hammering it with simultaneous reloads from every screen.
            const delayMs = 2000 + Math.floor(Math.random() * 3000);
            console.warn(`[console] Session closed by server — reloading screen in ${delayMs}ms`);
            setTimeout(() => reloadScreen('session-fermee'), delayMs);
        });
        return unsubscribe;
    }, []);

    return null;
}
